const PageBreakElement = ({ element }) => {
    return (
        <div className="text-center">
            <h3 style={{fontStyle:"italic"}} className="editable-label clickable-label">NEW PAGE</h3>
        </div>
    );
}

export default PageBreakElement